import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyAccountComponent } from './verify-account.component';
import { TranslateModule, LoaderModule } from '@xref/ngx';

@NgModule({
    declarations: [VerifyAccountComponent],
    imports: [
        CommonModule,
        TranslateModule,
        LoaderModule
    ]
})
export class VerifyAccountModule {}
